import React from 'react'
import styled from 'styled-components'
import { Text } from '../Text'
import { STYLES } from '../../static/style'
import { TextBox } from '../TextBox/TextBox'
import { SelectionFieldType } from './SelectionFieldType'
import { SelectionType } from './SelectionType'
import { ISelectionItemProps } from './SelectionItemProp'

const StyledSelectionItem = styled.label`
  ${({ isInline }: { isInline?: boolean }) =>
    isInline
      ? `
    display: inline-block;
    margin-right: 1rem;
  `
      : `
    display: block;
  `}
`

const SelectionItemContent = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0.5rem 0;
`

const SelectionItemField = styled.input`
  margin-right: ${STYLES.GUTTER};
`

const LabelText = styled(Text)``

const StyledTextBox = styled(TextBox)`
  margin-top: 0;
  margin-bottom: 0;
`

const SelectionItem: React.FC<ISelectionItemProps> = ({
  children,
  text,
  value,
  type = SelectionType.RADIO,
  isInline,
  fieldType = SelectionFieldType.NORMAL,
  selected = false,
  onChange,
  placeholder, // for text box only
}) => {
  const isCheckbox = type === SelectionType.CHECKBOX
  return (
    <StyledSelectionItem isInline={isInline}>
      <SelectionItemContent>
        <SelectionItemField
          type={isCheckbox ? 'checkbox' : 'radio'}
          selected={selected}
          checked={selected}
          onChange={(ev) => {
            onChange(ev, isCheckbox ? ev.target.checked : ev.target.selected)
          }}
        />
        <LabelText>
          {fieldType === SelectionFieldType.NORMAL ? (
            text || children
          ) : fieldType === SelectionFieldType.TEXTBOX ? (
            <StyledTextBox
              placeholder={placeholder}
              onChange={onChange}
              value={value || ''}
            />
          ) : (
            'Not support'
          )}
        </LabelText>
      </SelectionItemContent>
    </StyledSelectionItem>
  )
}

export { SelectionItem }
